/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateApiKeyRequestDto,
  CreateOrganizationApiKeyParams,
  ListOrganizationApiKeysParams,
  OrganizationApiKeyDto,
  OrganizationApiKeyWithSecretDto,
  RevokeOrganizationApiKeyParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCreateOrganizationApiKeyUrl = (params: CreateOrganizationApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api-keys?${stringifiedParams}` : `/api-keys`
}

export const createOrganizationApiKey = async (createApiKeyRequestDto: CreateApiKeyRequestDto,
    params: CreateOrganizationApiKeyParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationApiKeyWithSecretDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<OrganizationApiKeyWithSecretDto>(getCreateOrganizationApiKeyUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createApiKeyRequestDto)
  }
);}





export const getCreateOrganizationApiKeyMutationKey = () => ['createOrganizationApiKey'] as const;

export const getCreateOrganizationApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationApiKey>>, TError,CreateOrganizationApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganizationApiKey>>, TError,CreateOrganizationApiKeyMutationVariables, TContext> => {

const mutationKey = getCreateOrganizationApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganizationApiKey>>, CreateOrganizationApiKeyMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  createOrganizationApiKey(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganizationApiKey>>>
    export type CreateOrganizationApiKeyMutationBody = CreateApiKeyRequestDto
    export type CreateOrganizationApiKeyMutationError = unknown
    export type CreateOrganizationApiKeyMutationVariables = {data: CreateApiKeyRequestDto;params: CreateOrganizationApiKeyParams}

    export const useCreateOrganizationApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationApiKey>>, TError,CreateOrganizationApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganizationApiKey>>,
        TError,
        CreateOrganizationApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrganizationApiKeyMutationOptions(options), queryClient);
    }
    export const getListOrganizationApiKeysUrl = (params: ListOrganizationApiKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api-keys?${stringifiedParams}` : `/api-keys`
}

export const listOrganizationApiKeys = async (params: ListOrganizationApiKeysParams, options?: Parameters<typeof customFetch>[1]): Promise<OrganizationApiKeyDto[]> => {

  return customFetch<OrganizationApiKeyDto[]>(getListOrganizationApiKeysUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationApiKeysQueryKey = (params?: ListOrganizationApiKeysParams,) => {
    return [
    `/api-keys`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrganizationApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError = unknown>(params: ListOrganizationApiKeysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationApiKeysQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationApiKeys>>> = ({ signal }) => listOrganizationApiKeys(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationApiKeys>>>
export type ListOrganizationApiKeysQueryError = unknown


export function useListOrganizationApiKeys<TData = Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError = unknown>(
 params: ListOrganizationApiKeysParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationApiKeys>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationApiKeys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationApiKeys<TData = Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError = unknown>(
 params: ListOrganizationApiKeysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationApiKeys>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationApiKeys>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationApiKeys<TData = Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError = unknown>(
 params: ListOrganizationApiKeysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationApiKeys<TData = Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError = unknown>(
 params: ListOrganizationApiKeysParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationApiKeys>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationApiKeysQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRevokeOrganizationApiKeyUrl = (id: string,
    params: RevokeOrganizationApiKeyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api-keys/${id}?${stringifiedParams}` : `/api-keys/${id}`
}

export const revokeOrganizationApiKey = async (id: string,
    params: RevokeOrganizationApiKeyParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeOrganizationApiKeyUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeOrganizationApiKeyMutationKey = () => ['revokeOrganizationApiKey'] as const;

export const getRevokeOrganizationApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrganizationApiKey>>, TError,RevokeOrganizationApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeOrganizationApiKey>>, TError,RevokeOrganizationApiKeyMutationVariables, TContext> => {

const mutationKey = getRevokeOrganizationApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeOrganizationApiKey>>, RevokeOrganizationApiKeyMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  revokeOrganizationApiKey(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeOrganizationApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeOrganizationApiKey>>>

    export type RevokeOrganizationApiKeyMutationError = unknown
    export type RevokeOrganizationApiKeyMutationVariables = {id: string;params: RevokeOrganizationApiKeyParams}

    export const useRevokeOrganizationApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeOrganizationApiKey>>, TError,RevokeOrganizationApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeOrganizationApiKey>>,
        TError,
        RevokeOrganizationApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeOrganizationApiKeyMutationOptions(options), queryClient);
    }
